//emoji表情
let xhsemojis = [{ title: "微笑R", file: "icon/weixiao-1.png" },
{ title: "害羞R", file: "icon/haixiu-1.png" },
{ title: "失望R", file: "icon/shiwang-1.png" },
{ title: "汗颜R", file: "icon/hanyan-1.png" },
{ title: "哇R", file: "icon/wa-1.png" },
{ title: "喝奶茶R", file: "icon/henaicha-1.png" },
{ title: "自拍R", file: "icon/zipai-1.png" },
{ title: "偷笑R", file: "icon/touxiao-1.png" },
{ title: "飞吻R", file: "icon/feiwen-1.png" },
{ title: "石化R", file: "icon/shihua-1.png" },
{ title: "笑哭R", file: "icon/xiaoku-1.png" },
{ title: "赞R", file: "icon/zan-1.png" },
{ title: "暗中观察R", file: "icon/anzhongguancha-1.png" },
{ title: "买爆R", file: "icon/maibao-1.png" },
{ title: "大笑R", file: "icon/daxiao-1.png" },
{ title: "色色R", file: "icon/sese-1.png" },
{ title: "生气R", file: "icon/shengqi-1.png" },
{ title: "哭惹R", file: "icon/kure-1.png" },
{ title: "萌萌哒R", file: "icon/mengmengda-1.png" },
{ title: "斜眼R", file: "icon/xieyan-1.png" },
{ title: "可怜R", file: "icon/kelian-1.png" },
{ title: "鄙视R", file: "icon/bishi-1.png" },
{ title: "皱眉R", file: "icon/zhoumei-1.png" },
{ title: "抓狂R", file: "icon/zhuakuang-1.png" },
{ title: "捂脸R", file: "icon/wulian-1.png" },
{ title: "派对R", file: "icon/paidui-1.png" },
{ title: "吧唧R", file: "icon/baji-1.png" },
{ title: "惊恐R", file: "icon/jingkong-1.png" },
{ title: "抠鼻R", file: "icon/koubi-1.png" },
{ title: "再见R", file: "icon/zaijian-1.png" },
{ title: "叹气R", file: "icon/tanqi-1.png" },
{ title: "睡觉R", file: "icon/shuijiao-1.png" },
{ title: "得意R", file: "icon/deyi-1.png" },
{ title: "吃瓜R", file: "icon/chigua-1.png" },
{ title: "扶墙R", file: "icon/fuqiang-1.png" },
{ title: "黑薯问号R", file: "icon/heishuwenhao-1.png" },
{ title: "黄金薯R", file: "icon/huangjinshu.png" },
{ title: "吐舌头H", file: "icon/tushetou-1.png" },
{ title: "扯脸H", file: "icon/chelian-1.png" },
{ title: "doge", file: "icon/doge-1.png" },
// -------------- emoji----------
{ title: "天幕R", file: "emoji/huwai-tianmu-1.png" },
{ title: "卡式炉R", file: "emoji/huwai-kashilu-1.png" },
{ title: "折叠椅R", file: "emoji/huwai-zhedieyi-1.png" },
{ title: "营地车R", file: "emoji/huwai-yingdiche-1.png" },
{ title: "露营灯R", file: "emoji/huwai-luyingdeng-1.png" },
{ title: "露营R", file: "emoji/Rectangle-1.png" },
{ title: "渔夫帽R", file: "emoji/huwai-yufumao-1.png" },
{ title: "登山鞋R", file: "emoji/huwai-dengshanxie-1.png" },
{ title: "背包R", file: "emoji/huwai-beibao-1.png" },
{ title: "马甲R", file: "emoji/huwai-majia-1.png" },
{ title: "骑行服R", file: "emoji/huwai-qixingfu-1.png" },
{ title: "手套R", file: "emoji/huwai-shoutao-1.png" },
{ title: "头盔R", file: "emoji/huwai-toukui-1.png" },
{ title: "风镜R", file: "emoji/huwai-fengjing-1.png" },
{ title: "公路车R", file: "emoji/huwai-gongluche-1.png" },
{ title: "折叠车R", file: "emoji/huwai-zhedieche-1.png" },
{ title: "飞盘R", file: "emoji/huwai-feipan-1.png" },
{ title: "冲浪板R", file: "emoji/huwai-chonglangban-1.png" },
{ title: "双翘滑板R", file: "emoji/huwai-shuangqiaohuaban-1.png" },
{ title: "陆冲板R", file: "emoji/huwai-luchongban-1.png" },
{ title: "长板R", file: "emoji/huwai-changban-1.png" },
{ title: "种草R", file: "emoji/zhongcao-1.png" },
{ title: "拔草R", file: "emoji/bacao-1.png" },
{ title: "点赞R", file: "emoji/dianzan-1.png" },
{ title: "向右R", file: "emoji/xiangyou-1.png" },
{ title: "合十R", file: "emoji/heshi-1.png" },
{ title: "okR", file: "emoji/OK-1.png" },
{ title: "加油R", file: "emoji/jiayou-1.png" },
{ title: "握手R", file: "emoji/woshou-1.png" },
{ title: "鼓掌R", file: "emoji/guzhuang.png" },
{ title: "弱R", file: "emoji/ruo-1.png" },
{ title: "耶R", file: "emoji/yeah-1.png" },
{ title: "抱拳R", file: "emoji/baoquan-1.png" },
{ title: "勾引R", file: "emoji/gouying-1.png" },
{ title: "拳头R", file: "emoji/quntou.png" },
{ title: "拥抱R", file: "emoji/yongbao.png" },
{ title: "举手R", file: "emoji/jushou.png" },
{ title: "猪头R", file: "emoji/zhutou.png" },
{ title: "老虎R", file: "emoji/laohu.png" },
{ title: "集美R", file: "emoji/jimei.png" },
{ title: "仙女R", file: "emoji/xiannv.png" },
{ title: "红书R", file: "emoji/hongshu.png" },
{ title: "开箱R", file: "emoji/kaixiang.png" },
{ title: "探店R", file: "emoji/shangdian.png" },
{ title: "ootdR", file: "emoji/ootd.png" },
{ title: "同款R", file: "emoji/tongkuan.png" },
{ title: "打卡R", file: "emoji/daka.png" },
{ title: "飞机R", file: "emoji/feiji.png" },
{ title: "拍立得R", file: "emoji/palide.png" },
{ title: "薯券R", file: "emoji/shuquan.png" },
{ title: "优惠券R", file: "emoji/youhuiquan.png" },
{ title: "购物车R", file: "emoji/gouwuche.png" },
{ title: "kissR", file: "emoji/kiss.png" },
{ title: "礼物R", file: "emoji/liwu.png" },
{ title: "生日蛋糕R", file: "emoji/shengridangao.png" },
{ title: "私信R", file: "emoji/sixin.png" },
{ title: "请文明R", file: "emoji/qingwenming.png" },
{ title: "请友好R", file: "emoji/qingyouhao.png" },
{ title: "氛围感R", file: "emoji/fenweigan.png" },
{ title: "清单R", file: "emoji/qingdan.png" },
{ title: "电影R", file: "emoji/dianying.png" },
{ title: "学生党R", file: "emoji/xueshengdang.png" },
{ title: "彩虹R", file: "emoji/caihong.png" },
{ title: "爆炸R", file: "emoji/baozha.png" },
{ title: "炸弹R", file: "emoji/zhadan.png" },
{ title: "火R", file: "emoji/huo.png" },
{ title: "啤酒R", file: "emoji/pijiu.png" },
{ title: "咖啡R", file: "emoji/Rectangle.png" },
{ title: "钱袋R", file: "emoji/qiandai.png" },
{ title: "流汗R", file: "emoji/liuhan.png" },
{ title: "发R", file: "emoji/fa.png" },
{ title: "红包R", file: "emoji/hongbao.png" },
{ title: "福R", file: "emoji/fu.png" },
{ title: "鞭炮R", file: "emoji/bianpao.png" },
{ title: "庆祝R", file: "emoji/qingzhu.png" },
{ title: "烟花R", file: "emoji/yanhua.png" },
{ title: "气球R", file: "emoji/qiqiu.png" },
{ title: "看R", file: "emoji/kan.png" },
{ title: "新月R", file: "emoji/xinyue.png" },
{ title: "满月R", file: "emoji/manyue.png" },
{ title: "大便R", file: "emoji/dabian.png" },
{ title: "太阳R", file: "emoji/taiyang.png" },
{ title: "晚安R", file: "emoji/wanan.png" },
{ title: "星R", file: "emoji/xing.png" },
{ title: "玫瑰R", file: "emoji/meigui.png" },
{ title: "凋谢R", file: "emoji/kuwei.png" },
{ title: "郁金香R", file: "emoji/yujinxiang.png" },
{ title: "樱花R", file: "emoji/yinhua.png" },
{ title: "海豚R", file: "emoji/haitun.png" },
{ title: "放大镜R", file: "emoji/fangdajing.png" },
{ title: "刀R", file: "emoji/dao.png" },
{ title: "辣椒R", file: "emoji/lajiao.png" },
{ title: "黄瓜R", file: "emoji/haunggua.png" },
{ title: "葡萄R", file: "emoji/putao.png" },
{ title: "草莓R", file: "emoji/caomei.png" },
{ title: "桃子R", file: "emoji/taozi.png" },
{ title: "红薯R", file: "emoji/hongshu-1.png" },
{ title: "栗子R", file: "emoji/lizi.png" },
{ title: "红色心形R", file: "emoji/hongsexingxing.png" },
{ title: "黄色心形R", file: "emoji/huangsexingxing.png" },
{ title: "绿色心形R", file: "emoji/lvsexingxing.png" },
{ title: "蓝色心形R", file: "emoji/lansexingxing.png" },
{ title: "紫色心形R", file: "emoji/zisexingxing.png" },
{ title: "爱心R", file: "emoji/aixing.png" },
{ title: "两颗心R", file: "emoji/liangkexin.png" },
{ title: "浅肤色R", file: "emoji/qianfuse.png" },
{ title: "中浅肤色R", file: "emoji/zhongxingfuse.png" },
{ title: "中等肤色R", file: "emoji/zhongdengfuse.png" },
{ title: "中深肤色R", file: "emoji/zhongshenfuse.png" },
{ title: "有R", file: "emoji/you.png" },
{ title: "可R", file: "emoji/ke.png" },
{ title: "蹲R", file: "emoji/dun.png" },
{ title: "零R", file: "emoji/ling.png" },
{ title: "一R", file: "emoji/yi.png" },
{ title: "二R", file: "emoji/er.png" },
{ title: "三R", file: "emoji/san.png" },
{ title: "四R", file: "emoji/si.png" },
{ title: "五R", file: "emoji/wu.png" },
{ title: "六R", file: "emoji/liu.png" },
{ title: "七R", file: "emoji/qi.png" },
{ title: "八R", file: "emoji/ba.png" },
{ title: "九R", file: "emoji/jiu.png" },
{ title: "加一R", file: "emoji/jiayi.png" },
{ title: "满R", file: "emoji/man.png" },
{ title: "禁R", file: "emoji/jin.png" },
]

const FILE_BASE_URL = "https://sybm.lm12301.com/xiaohs/"
//  在发送信息之后，将输入的内容中属于表情的部分替换成emoji图片标签
//  再经过v-html 渲染成真正的图片
function replaceXhsEmoji(con) {
  con = con + ''

  //找找中括号表情
  let regExp = /(?<=\[)(.+?)(?=\])/g
  let matchRes = con.match(regExp)
  if (!matchRes || matchRes.length == 0) {
    return con
  }

  for (let i = 0; i < matchRes.length; i++) {
    let emojStr = matchRes[i]
    let findItem = xhsemojis.find(item => item.title == emojStr)
    if (findItem) {
      let img = '<img src="' + FILE_BASE_URL + findItem.file + '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />'
      con = con.replace(new RegExp('\\[' + findItem.title + ']', 'g'), img)
    }

  }
  return con

  // if (con && con.includes('[') && con.includes(']')) {
  //   //查找

  //   for (var i = 0; i < emojis.length; i++) {
  //     let item = emojis[i]
  //     let img = '<img src="'+require("@assets/img/emoji/" +item.file )+ '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />'
  //     con = con.replace(new RegExp('\\[' + item.title + ']', 'g'), img)
  //   }
  //   return con;
  // }
  // return con;
}

function getXshFileAbsPath(fileName){
  return `${FILE_BASE_URL}${fileName}`
}


export {
  xhsemojis,
  replaceXhsEmoji,
  getXshFileAbsPath
}